export const VideoType = {
  WmtVideo: 'wmt_video',
  Youtube: 'youtube',
  Facebook: 'facebook',
  Hls: 'hls',
} as const
